module.exports = __webpack_public_path__ + "static/media/white_search.c0662500.svg";